import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { getDataPatientsHcProvider, getPatientsHcProvider } from '../../app/actions/appActions';
import User from '../../components/User';

import './styles.scss';

const Patients = () => {
	const dispatch = useDispatch()
	const patients = useSelector(state => state.app.patientsHcProvider);
	const dataPatients = useSelector(state => state.app.dataPatients);
	const auth = useSelector((state) => state.firebase.auth);

	useEffect(() => {
		if(!patients.length) {
			dispatch(getPatientsHcProvider(auth.uid));
		};
		dispatch(getDataPatientsHcProvider(patients));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[patients]);

	return (
		<div>
			{
				dataPatients.map((patient,i) => {
					return (
						<Link to={`/patient/${patient.userId}`} key={i}>
							<User user={patient} withEmail isBig/>
						</Link>
					)
				})
			}
		</div>
	)
};

export default Patients;
